import React from 'react';
import { Navbar } from '../components/Navbar';
import { ResearchPage } from '../components/ResearchPage';
import { Footer } from '../components/Footer';
export const Research = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2365" data-mp="2ntrdgbo25nbb">
      <Navbar data-id="element-2366" data-mp="2nr4ulfvpvlds" />
      <ResearchPage data-id="element-2367" data-mp="2nremj90bo2m4" />
      <Footer data-id="element-2368" data-mp="2srsw4vhknkm9" />
    </div>;
};